import { put, select } from 'redux-saga/effects';
import { putEntities } from '../../redux/entities/actions';
import { getGallectionById } from '../selectors';
import type { Action } from 'redux-actions';
import type { SetGallectionPricePayload } from '../actions';
import { normalizeGallection } from '../../redux/normalizr/helpers';
import type { PapiGallection } from '@wix/da-papi-types';

function* setGallectionPrice(action: Action<SetGallectionPricePayload>) {
  const { folderId, pointsPrice } = action.payload;
  const gallection: ReturnType<typeof getGallectionById> = yield select(
    getGallectionById,
    folderId
  );
  if (!gallection) {
    return;
  }

  const updatedGallection: PapiGallection = {
    ...gallection,
    premiumFolderData: {
      type: 'paid',
      hasAccess: true,
      ...gallection.premiumFolderData,
      pointsPrice,
    },
  };

  const entities = normalizeGallection(updatedGallection);

  yield put(putEntities({ entities }));
}

export default setGallectionPrice;
